import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard CRM
import DashboardReducer from "./dashboard/reducer";

// User
import UserReducer from "./user/reducer";

// Role
import RoleReducer from "./role/reducer";

// Global
import GlobalReducer from "./global/reducer";


// News
import NewsReducer from "./news/reducer";

// Category
import CategoryReducer from "./category/reducer";

// Keyword
import KeywordReducer from "./keyword/reducer";

// System
import SystemReducer from "./system/reducer";

// Image
import ImageReducer from "./image/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Dashboard: DashboardReducer,
    User: UserReducer,
    Role: RoleReducer,
    Global: GlobalReducer,
    News: NewsReducer,
    Category: CategoryReducer,
    Keyword: KeywordReducer,
    System: SystemReducer,
    Image: ImageReducer,
});

export default rootReducer;